import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';

import { checkForErrors } from '../../utils';
import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';
import { GetBotData } from '../prostudio.api-service.types';

export const loadBots = async (
  ctx: ProStudioContext,
  _event: ProStudioEvents
): Promise<{
  solutions: ProStudioContext['solutions'];
}> => {
  const { customerId, project } = ctx;

  const projectId = project?.id;
  const projectProStudioSettingId = project?.projectProStudioSetting?.id;

  if (!customerId) {
    throwErrorWithId('Customer ID is required');
    return { solutions: [] };
  }

  if (!projectId) {
    throwErrorWithId('Project ID is required');
    return { solutions: [] };
  }

  if (!projectProStudioSettingId) {
    throwErrorWithId('Project Pro Studio Setting ID is required');
    return { solutions: [] };
  }

  const [solutionsResponse, customerDataResponse] = await Promise.all([
    urqlGql.getSolutions({
      projectProStudioSettingId,
    }),
    urqlGql.getCustomerData({
      customerId,
      projectId,
    }),
  ]);

  checkForErrors(solutionsResponse);
  checkForErrors(customerDataResponse);

  const { data: solutionsData } = solutionsResponse;
  const { data: customerData } = customerDataResponse;

  const solutions = solutionsData?.admin_?.solutions;

  const botResponses = await Promise.all(
    customerData?.getCustomerBots?.data?.map((bot) =>
      urqlGql.getBotById({ botId: bot, projectId })
    ) || []
  );

  const bots = botResponses
    .map((bot) => bot.data?.getBotById?.data)
    .filter(Boolean) as GetBotData['getBotById']['data'][];

  const mergedSolutions = solutions?.map((solution) => {
    const sol = bots.find((b) => b?.id === solution?.botSolutionId);
    return {
      ...sol,
      ...solution,
    };
  });

  return {
    solutions: mergedSolutions,
  };
};
